import { ApiError } from '../api/client';

/**
 * One mapping, shared by `HomePage` and `OrderForm` — the REFACTOR task
 * in `tasks.md` PR 7 asks for exactly this: the same 422/409 code always
 * reads the same in both places, never duplicated per component.
 */
const ERROR_MESSAGES: Record<string, string> = {
  ORDER_CUTOFF_PASSED: 'El horario de corte ya pasó para esta fecha.',
  MENU_QUOTA_EXCEEDED: 'El cupo de ese menú ya se agotó.',
  ORDER_MENU_NOT_AVAILABLE: 'Ese menú no está disponible para la fecha elegida.',
  ORDER_CHANGE_ALREADY_PENDING:
    'Ya tenés una solicitud de cambio en revisión para este pedido. Esperá a que se resuelva.',
  ORDER_LOCKED: 'Este pedido ya está confirmado. Solicitá un cambio en su lugar.',
  ORDER_CANCELLATION_REASON_REQUIRED: 'Indicá un motivo para cancelar el pedido.',
  ORDER_USER_QUANTITY_LIMIT_EXCEEDED: 'Superaste tu tope diario de unidades.',
  ORDER_QUANTITY_LIMIT_EXCEEDED: 'La cantidad supera el tope del contrato.',
  CANNOT_PLACE_ORDERS: 'Tu acceso no permite cargar pedidos. Contactá a tu proveedor.',
  SERVICE_DATE_NOT_AVAILABLE: 'Esa fecha no está habilitada para pedidos.',
  ORDER_TEMPLATE_INVALID_DAYS:
    'Elegiste un día inválido: usá valores entre 1 (lunes) y 7 (domingo).',
  MENU_POSITION_INACTIVE: 'Esa posición del menú ya no está activa.',
  ORDER_TEMPLATE_DUPLICATE_POSITION: 'No podés repetir la misma posición en una plantilla.',
  ORDER_ALREADY_EXISTS:
    'Ya cargaste un pedido para esa sede y fecha. Buscalo en Pedidos y editalo.',
  NO_ACTIVE_CONTRACT: 'No hay un contrato vigente para esa fecha. Contactá a tu proveedor.',
  OPERATING_UNIT_REQUIRED: 'Elegí un punto de venta para el pedido.',
  ORDER_EMPTY: 'Cargá al menos un plato con cantidad para poder enviar el pedido.',
  ORDER_OVERRIDE_REASON_REQUIRED: 'Indicá el motivo para cargar el pedido fuera del horario de corte.',
  ORDER_CHANGE_INVALID_STATUS: 'Este pedido ya no se puede modificar en su estado actual.',
};

export function describeOrderError(error: unknown): string {
  if (error instanceof ApiError) {
    const code = (error.body as { code?: string } | null)?.code;

    if (code !== undefined && ERROR_MESSAGES[code] !== undefined) {
      return ERROR_MESSAGES[code];
    }

    return 'No pudimos completar la acción. Probá de nuevo.';
  }

  return 'Ocurrió un error inesperado. Probá de nuevo.';
}
